const $ = jQuery.noConflict();

class Slider {
    constructor(sel, fade = false, num = 1, tabNum = 1, slideSpeed = 600, variableWidth = false) {
        this.selector = sel;
        this.num = num;
        this.tabNum = tabNum;
        this.variableWidth = variableWidth;
        this.slideSpeed = slideSpeed;
        this.fade = fade;
    }
    init() {
        const {
            num,
            fade,
            tabNum,
            slideSpeed,
            variableWidth,
        } = this;

        function slideSettings() {
            $(this).slick({
                dots: false,
                arrows: true,
                infinite: true,
                slidesToShow: num,
                slidesToScroll: 1,
                variableWidth,
                fade,
                prevArrow: '<button class="slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="8px" viewBox="-298 393 14 8" style="enable-background:new -298 393 14 8;" xml:space="preserve"><path style="fill:#00853E;" d="M-285,401c-0.3,0-0.5-0.1-0.7-0.3l-5.3-5.3l-5.3,5.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0l6,6c0.4,0.4,0.4,1,0,1.4C-284.5,400.9-284.7,401-285,401"/></svg></button>',
                nextArrow: '<button class="slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="8px" viewBox="-298 393 14 8" style="enable-background:new -298 393 14 8;" xml:space="preserve"><path style="fill:#00853E;" d="M-285,401c-0.3,0-0.5-0.1-0.7-0.3l-5.3-5.3l-5.3,5.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0l6,6c0.4,0.4,0.4,1,0,1.4C-284.5,400.9-284.7,401-285,401"/></svg></button>',
                appendArrows: $(this).siblings('.slider__arrows'),
                pauseOnHover: false,
                speed: slideSpeed,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: tabNum,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }
        $(this.selector).each(slideSettings);
    }
}
const SimpleSlider = new Slider('.bc-gallery__slider');
const LightboxSlider = new Slider('.lightbox-gallery__slider');

export { SimpleSlider, LightboxSlider };
